/**
 * @file 侧边导航底部
 * @author sunyingying01
 */

import React, {useMemo} from 'react';
import {observer} from 'mobx-react-lite';

import QuestionSvg from '@assets/icons/question.svg';

import DocSvg from '@assets/icons/doc.svg';
import ConnectSvg from '@assets/icons/connect.svg';
import GuideModal from '@/components/GuideModal';
import LinkSvg from '@/assets/icons/link.svg';
import styles from './index.module.less';

interface MenusItem {
    key: string;
    title: string;
    icon: React.ReactNode;
    url: string;
}

interface IGuideMenuProps {
    onOpenGuide: () => void;
    guideModalVisible: boolean;
    onClose: (visible?: boolean) => void;
}


const GuideMenu: React.FC<IGuideMenuProps> = props => {

    const handleGuideClick = (item: MenusItem) => {
        if (item.url) {
            window.open(item.url, '_blank');
            return;
        }
        props.onOpenGuide();
    };

    const menuItems = useMemo(
        () => [
            {
                key: 'guide',
                title: '新手引导',
                icon: <QuestionSvg />,
                url: ''
            },
            {
                key: 'doc',
                title: '使用文档',
                icon: <DocSvg />,
                url: 'https://cloud.baidu.com/doc/famou/index.html'
            },
            {
                key: 'contact',
                title: '联系我们',
                icon: <ConnectSvg />,
                url: 'https://cloud.baidu.com/survey/famou-from.html'
            }
        ],
        []
    );
    return (
        <div className={styles.guideWrapper}>
            {menuItems.map(item => (
                <a key={item.key} onClick={() => handleGuideClick(item)}>
                    <div className={styles.guideBtn}>
                        <div className={styles.left}>
                            <div className={styles.icon}>
                                {item.icon}
                            </div>
                            <div className={styles.title}>
                                {item.title}
                            </div>
                        </div>
                        {item.url && (
                            <div className={styles.right}>
                                <LinkSvg />
                            </div>
                        )}
                    </div>
                </a>
            ))}
            <GuideModal
                visible={props.guideModalVisible}
                onClose={props.onClose}
            />
        </div>
    );
};

export default observer(GuideMenu);
